import Calc from './Calc'

export default Calc
